export interface VersionDto {
    name: string;
    version: string;
}

export const DefaultVersionDto: VersionDto = {
    name: '',
    version: '',
};
